<template>
    <div
        v-if="currentList && currentList.length"
        class="advancedSelect"
        :class="[
            {
                'advancedSelect--open': isOpen,
                'align-right': alignRight,
                'bottom-space': bottomSpace,
                'without-min-width': withoutMinWidth,
            },
            modifierClass,
        ]"
        @keydown.prevent="onInput"
        @keyup.prevent="onKeyUp"
    >
        <div class="advancedSelect-component" ref="listMount">
            <span v-if="showLabel" class="advancedSelect-label">
                <slot :label="label" name="label">{{ label }}</slot>
            </span>

            <a v-if="!customHeader" v-click-outside="onHeaderClickOutside" href="#" class="advancedSelect-header" @click.prevent="onHeaderClick">
                <span class="advancedSelect-inner advancedSelect-inner--header">
                    <span v-if="!currentItem" class="advancedSelect-headerValue">
                        - <slot :placeholder="placeholder" name="placeholder">{{ placeholder }}</slot> -
                    </span>
                    <span v-else class="advancedSelect-headerValue">
                        <slot :option="currentItem" name="header">{{ customDateFilter && currentItem.key === 'custom' ? customDateFilter : currentItem.title }}</slot>
                    </span>

                    <span class="icon icon--bostonBlue icon--arrowDown advancedSelect-headerArrow"></span>
                </span>
            </a>

            <a v-else v-click-outside="onHeaderClickOutside" href="#" class="advancedSelect-custom-header" @click.prevent="onHeaderClick">
                <slot name="customHeader" :is-open="isOpen" :current-item="currentItem" />
            </a>

            <span
                v-click-outside="onListClickOutside"
                v-show="isOpen"
                ref="optionlist"
                class="advancedSelect-options"
                :class="[
                    {
                        empty: !currentList || !currentList.length,
                        fluid: fluidOnMobile,
                        injectInRoot: injectInRoot,
                    },
                    modifierClass,
                ]"
            >
                <slot name="topLogo" />
                <span class="advancedSelect-inner advancedSelect-inner--options" ref="optionlistInner">
                    <a
                        v-for="(option, index) in currentList"
                        :key="option.id || index"
                        :data-option-value="option.value || option.id"
                        :data-option-index="index"
                        :data-option-id="option.id"
                        :class="[option.options ? 'advancedSelect-item--hasSubs' : '', focusedItem ? (option.id === focusedItem.id ? 'advancedSelect-item-focused' : '') : false, !preventIconDisplay && (largeOptions || option.icon) ? 'advancedSelect-item--largeOption' : '', ...(option.modifiers || [])]"
                        href="#"
                        class="advancedSelect-item"
                        @click.prevent="onItemClick"
                        @mouseover.prevent="focusItemById(option.id, true)"
                    >
                        <slot :option="option" :name="`option--${option.key}`">
                            <slot :option="option" :currentItem="currentItem" name="option">
                                <span>{{ option.title }}</span>
                                <span v-if="option.icon" class="icon" :class="['icon--' + option.color, 'icon--' + option.icon]" />
                            </slot>
                        </slot>
                    </a>
                </span>
                <slot name="bottomNote" />
                <span class="advancedSelect-scrollBar" ref="scrollBar" v-show="overFlow">
                    <span class="advancedSelect-scrollBar--indicator" ref="scrollBarIndicator"></span>
                </span>
            </span>
        </div>
    </div>
</template>

<script src="./AdvancedSelect.js"></script>
